(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ri-more-in-size')) {
    class RIMoreInSize extends HTMLElement {
      connectedCallback() { if (this.loading) return; this.loading = true; this.load(); }
      normalizeSize(value) {
        const normalized = String(value || '').toLowerCase().replace(/[\s_-]+/g, '');
        const aliases = { XS:['xs','xsmall','extrasmall','xtrasmall'], S:['s','small'], M:['m','medium'], L:['l','large'], XL:['xl','xlarge','extralarge','xtralarge'], '2XL':['xxl','2xl','xxlarge','2xlarge','extraextralarge'], '3XL':['xxxl','3xl','xxxlarge','3xlarge','extraextraextralarge'] };
        for (const [canonical, values] of Object.entries(aliases)) if (values.includes(normalized)) return canonical;
        return '';
      }
      async load() {
        const size = this.normalizeSize(this.dataset.size);
        if (!size) return;
        const cards = new Map();
        let page = 1;
        try {
          for (let requests = 0; requests < 4; requests += 1) {
            const url = new URL(this.dataset.collectionUrl, location.origin);
            url.searchParams.set('section_id','ri-size-data');
            url.searchParams.set('filter.v.availability','1');
            url.searchParams.set('sort_by','created-descending');
            url.searchParams.set('page',String(page));
            const preview = new URL(location.href).searchParams.get('preview_theme_id');
            if (preview) url.searchParams.set('preview_theme_id',preview);
            const response = await fetch(url,{credentials:'same-origin',cache:'no-store'});
            if (!response.ok) throw new Error('catalog');
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            const root = doc.querySelector('[data-ri-catalog-page]');
            if (!root) throw new Error('catalog');
            root.querySelectorAll('.ri-card[data-ri-product-id]').forEach(card => {
              if (card.dataset.riProductId === this.dataset.productId) return;
              if (!card.dataset.riSizes?.includes('|' + size + '|')) return;
              cards.set(card.dataset.riProductId,card);
            });
            if (cards.size >= 4) break;
            const next = Number(root.dataset.riNextPage);
            if (!next || !Number.isInteger(next) || next <= page) break;
            page = next;
          }
          const matches = Array.from(cards.values()).slice(0,4);
          if (!matches.length || !this.isConnected) return;
          const grid = this.querySelector('[data-ri-more-size-grid]');
          const fragment = document.createDocumentFragment();
          matches.forEach(card => {
            const clone = card.cloneNode(true);
            const variant = Array.from(clone.querySelectorAll('[data-ri-variant-size]')).find(item => item.dataset.riVariantSize === size);
            if (variant) clone.querySelector('.ri-card__link')?.setAttribute('href',variant.dataset.riVariantUrl);
            fragment.append(clone);
          });
          grid.replaceChildren(fragment);
          this.hidden = false;
        } catch (error) { this.hidden = true; }
      }
    }
    customElements.define('ri-more-in-size',RIMoreInSize);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ri-fit-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ri-measurements')) {
  customElements.define('ri-measurements', class extends HTMLElement {
    connectedCallback() {
      const description = (this.dataset.description || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ');
      const fields = [
        ['Shoulder width', /\bshoulder\s*(?:width)?\s*[-:–]?\s*(\d{1,2}(?:\.\d+)?)\s*\.?\s*(?:inches|inch|in)?\b/i, 6, 40],
        ['Waist', /\bwaist\s*[-:–]?\s*(\d{1,2}(?:\.\d+)?)\s*\.?\s*(?:inches|inch|in)?\b/i, 15, 60],
        ['Length', /\blength\s*[-:–]?\s*(\d{1,2}(?:\.\d+)?)\s*\.?\s*(?:inches|inch|in)?\b/i, 12, 60]
      ];
      const grid = this.querySelector('[data-measurement-grid]');
      let found = 0;
      for (const [label, pattern, minimum, maximum] of fields) {
        const match = description.match(pattern);
        if (!match) continue;
        const amount = Number(match[1]);
        if (!Number.isFinite(amount) || amount < minimum || amount > maximum) continue;
        const cell = document.createElement('div');
        const heading = document.createElement('span');
        const value = document.createElement('strong');
        heading.textContent = label;
        value.textContent = amount + ' in';
        cell.append(heading, value);
        grid.append(cell);
        found++;
      }
      if (found) this.hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
